/*
This action file conatin the action related to templates file
*/
import * as api from '../api';

export const TEMPLATES_FETCH_REQUEST = 'TEMPLATES_FETCH_REQUEST';
export const TEMPLATES_FETCH_FAILURE = 'TEMPLATES_FETCH_FAILURE';
export const TEMPLATES_FETCH_SUCCESS = 'TEMPLATES_FETCH_SUCCESS';

export const fetchTemplates = (manualId) => {
  return (dispatch, getState) => {
    // TODO: Check if already fetching any templates
    // dispatch({
    //   type: TEMPLATES_FETCH_REQUEST
    // });

    api.fetchTemplates(manualId).then(
      (response) => {
        dispatch({
          type: TEMPLATES_FETCH_SUCCESS,
          manualId: manualId,
          templates: response
        });
      },
      (error) => {
        dispatch({
          type: TEMPLATES_FETCH_FAILURE,
          error: error,
          message: error.message || 'Could not fetch templates.'
        });
      }
    );
  };
};

export const TEMPLATE_PARAMS_UPDATE_REQUEST = 'TEMPLATE_PARAMS_UPDATE_REQUEST';
export const TEMPLATE_PARAMS_UPDATE_FAILURE = 'TEMPLATE_PARAMS_UPDATE_FAILURE';
export const TEMPLATE_PARAMS_UPDATE_SUCCESS = 'TEMPLATE_PARAMS_UPDATE_SUCCESS';

export const updateTemplateParams = (manualId, templateId, params) => {
  return (dispatch, getState) => {
    // TODO: Don't sent if there's already templates being fetched
    dispatch({
      type: TEMPLATE_PARAMS_UPDATE_REQUEST
    });

    api.updateTemplateParams(manualId, templateId, params).then(
      (response) => {
        dispatch({
          type: TEMPLATE_PARAMS_UPDATE_SUCCESS,
          manualId: manualId,
          templateId: templateId,
          updatedDoc: response
        });
        dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'Template updated',
          time: Date.now()
        });
      },
      (error) => {
        dispatch({
          type: TEMPLATE_PARAMS_UPDATE_FAILURE,
          error: error,
          message: error.message || 'Could not update the template'
        });
      }
    );
  }
};

export const TEMPLATE_FILE_UPLOAD_REQUEST = 'TEMPLATE_FILE_UPLOAD_REQUEST';
export const TEMPLATE_FILE_UPLOAD_SUCCESS = 'TEMPLATE_FILE_UPLOAD_SUCCESS';
export const TEMPLATE_FILE_UPLOAD_FAILURE = 'TEMPLATE_FILE_UPLOAD_FAILURE';

export const uploadTemplateFile = (manualId, templateId, companyId, files) => {
  return (dispatch, getState) => {
    dispatch({
      type: TEMPLATE_FILE_UPLOAD_REQUEST
    });

    return api.uploadTemplateFile(manualId, templateId, companyId, files).then(
      (response) => {
        dispatch({
          type: TEMPLATE_FILE_UPLOAD_SUCCESS,
          manualId: manualId,
          templateId: templateId,
          updatedDoc: response
        });
        dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'Template file uploaded',
          time: Date.now()
        });
        return response
      },
      (error) => {
        dispatch({
          type: TEMPLATE_FILE_UPLOAD_FAILURE,
          error: error,
          message: error.message || 'Could not upload the file'
        });
      }
    );
  };
};

export const uploadNewTemplateFile = (manualId, templateId, companyId, files, newMainTemplateName) => {
  return (dispatch, getState) => {
    dispatch({
      type: TEMPLATE_FILE_UPLOAD_REQUEST
    });

    return api.uploadNewTemplateFile(manualId, templateId, companyId, files,newMainTemplateName).then(
      (response) => {
        dispatch({
          type: TEMPLATE_FILE_UPLOAD_SUCCESS,
          manualId: manualId,
          templateId: templateId,
          updatedDoc: response
        });
        dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'Template file uploaded',
          time: Date.now()
        });
        return response
      },
      (error) => {
        dispatch({
          type: TEMPLATE_FILE_UPLOAD_FAILURE,
          error: error,
          message: error.message || 'Could not upload the file'
        });
      }
    );
  };
};

export const MANUALS_FETCH_REQUEST = 'MANUALS_FETCH_REQUEST';
export const MANUALS_FETCH_FAILURE = 'MANUALS_FETCH_FAILURE';
export const MANUALS_FETCH_SUCCESS = 'MANUALS_FETCH_SUCCESS';

export const fetchManuals = (companyId) => {
  return (dispatch, getState) => {
    // TODO: Check if already fetching

    // dispatch({
    //   type: MANUALS_FETCH_REQUEST
    // });

    api.fetchManuals(companyId).then(
      (response) => {
        dispatch({
          type: MANUALS_FETCH_SUCCESS,
          manuals: response
        });

        if( response ) {
          dispatch(fetchTemplates(response._id));
        }
      },
      (error) => {
        dispatch({
          type: MANUALS_FETCH_FAILURE,
          message: error.message || 'Could not fetch manuals',
          error: error
        });
      }
    );
  };
};

export const ADD_NEW_TEMPLATES_REQUEST = 'ADD_NEW_TEMPLATES_REQUEST';
export const ADD_NEW_TEMPLATES_FAILURE = 'ADD_NEW_TEMPLATES_FAILURE';
export const ADD_NEW_TEMPLATES_SUCCESS = 'ADD_NEW_TEMPLATES_SUCCESS';

export const addNewManual = (newManuals, companyId, tmpSetId) => {
  return (dispatch, getState) => {
    dispatch({
      type: ADD_NEW_TEMPLATES_REQUEST
    });

    api.addNewManual(newManuals, companyId, tmpSetId).then(
      (response) => {
        dispatch({
          type: ADD_NEW_TEMPLATES_SUCCESS,
        });
        dispatch({
          type: 'NOTIFICATION_ADD',
          text: 'New Manuals Added Successfully.',
        });
      },
      (error) => {
        dispatch({
          type: ADD_NEW_TEMPLATES_FAILURE,
          error: error,
          message: error.message || 'Could not upload the file'
        });
      }
    );
  }
}

const ADD_NEW_TEMPLATES_UNSET_FLAG = 'ADD_NEW_TEMPLATES_UNSET_FLAG'
export const unsetNewTemplateAddedFlag = () => {
  return (dispatch, getState) => {
    dispatch({
      type: ADD_NEW_TEMPLATES_UNSET_FLAG
    });
  }
}

export const SET_MAIN_TEMPLATE_REQUEST = 'SET_MAIN_TEMPLATE_REQUEST';
export const SET_MAIN_TEMPLATE_FAILURE = 'SET_MAIN_TEMPLATE_FAILURE';
export const SET_MAIN_TEMPLATE_SUCCESS = 'SET_MAIN_TEMPLATE_SUCCESS';

export const setMainTemplateToUse = (companyId, groupname, templateid) => {
  return (dispatch, getState) => {
    dispatch({
      type: SET_MAIN_TEMPLATE_REQUEST
    });

    api.setMainTemplateToUse(companyId, groupname, templateid).then(
      (response) => {

      },
      (error) => {
        dispatch({
          type: SET_MAIN_TEMPLATE_FAILURE,
          error: error,
          message: error.message || 'Could not set the this main template'
        });
      }
    );
  }
}

export const setAttachmentOrder = ( companyId, stockPartsAttachment, manaulsAttachment) => {
  return (dispatch, getState) =>{
    dispatch({
      type: 'SET_ATTACHMENT_SORT_REQUSET'
    });
    api.setAttachment(companyId, stockPartsAttachment, manaulsAttachment).then(
      (response) =>{

      },
      (error)=>{
        dispatch({
          type: 'SET_ATTACHMENT_SORT_FAILURE',
          error: error,
          message: error.message || 'Failed upload sort value'
        });
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/Actions/templates.js